import { startOfDay, endOfDay } from "date-fns";
import type { PlacementWithLocation } from "../types";

/**
 * Get the start and end boundaries for a given date
 * Used to query all placements that overlap with that day
 */
export const getDayBoundaries = (
  date: Date
): { start: Date; end: Date } => ({
  start: startOfDay(date),
  end: endOfDay(date),
});

/**
 * Deduplicate placements to show only the most recent per aircraft (by tail number)
 * Used in Daily mode where an aircraft may have multiple trips/positions during the day
 *
 * @param placements - Array of placements to deduplicate
 * @returns Array with one placement per aircraft (the most recent by start_time)
 */
export const getMostRecentPlacementPerAircraft = (
  placements: PlacementWithLocation[]
): PlacementWithLocation[] => {
  const byAircraft = new Map<string, PlacementWithLocation>();

  placements.forEach((p) => {
    // Use tail_number as the key (fall back to aircraft_id if tail_number is missing)
    const key = p.tail_number || p.aircraft_id || p.trip_id;
    const existing = byAircraft.get(key);
    if (
      !existing ||
      new Date(p.start_time).getTime() > new Date(existing.start_time).getTime()
    ) {
      byAircraft.set(key, p);
    }
  });

  return Array.from(byAircraft.values());
};
